import { Dispatch, SetStateAction, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { selectSurveyValues } from '@app/redux/disconnect';
import { scrollToTop } from '@app/redux/utils';

import { useHasFiberPreinstall } from './useHasFiberPreinstall';
import { DisconnectSteps } from '../types';

export const useNavigationHandler = (setStep: Dispatch<SetStateAction<DisconnectSteps>>) => {
  const dispatch = useDispatch();
  const { disconnectReason, otherReason } = useSelector(selectSurveyValues);
  const { t } = useTranslation();

  const hasFiberPreinstall = useHasFiberPreinstall();

  const [formError, setFormError] = useState<string | undefined>(undefined);
  const [radioError, setRadioError] = useState<string | undefined>(undefined);

  const handleIntroContinue = (step: DisconnectSteps) => {
    const error = document.querySelector('.beam-text-field__errors');
    if (error) {
      error.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    if (!disconnectReason) {
      setFormError(t('Disconnect:survey.error.text'));
      dispatch(scrollToTop());
    } else if (disconnectReason.includes(t('Disconnect:survey.other')) && !hasFiberPreinstall) {
      if (!otherReason) {
        setRadioError(t('Disconnect:survey.error.text'));
        dispatch(scrollToTop());

        return;
      }
      setRadioError(undefined);
      setFormError(undefined);

      setStep(step);
    } else {
      setFormError(undefined);

      setStep(step);
    }
  };

  const handleReviewCancel = (step: DisconnectSteps) => {
    setStep(step);
    dispatch(scrollToTop());
  };

  return {
    handleIntroContinue,
    handleReviewCancel,
    formError,
    setFormError,
    radioError,
    setRadioError,
  };
};
